import { FirestoreTimestampTimeAdapterService } from './../firestore-timestamp-time-adapter.service';
import { DayActivity, ItineraryActivityTypeData, Itinerary, AccomodationReservation, ItineraryActivityType } from "./../itineray.model";
import { Component, OnInit, Input } from "@angular/core";
import { DatePipe } from '@angular/common';
import { firestore } from 'firebase';

@Component({
  selector: "app-itinerary-day-activity-form",
  templateUrl: "./itinerary-day-activity-form.component.html",
  styleUrls: ["./itinerary-day-activity-form.component.css"]
})
export class ItineraryDayActivityFormComponent implements OnInit {
  @Input()
  activity: DayActivity;

  @Input()
  activityId: number;

  @Input()
  itinerary: Itinerary;

  @Input()
  disabled: boolean;

  activityTypesData = ItineraryActivityTypeData.values();

  constructor(public firestoreTimestampTimeAdapterService: FirestoreTimestampTimeAdapterService, private datePipe: DatePipe) { }

  ngOnInit() { }

  getActivityTypeData(type: ItineraryActivityType) {
    return ItineraryActivityTypeData.get(type);
  }

  transportationReservationToString(data: { start: firestore.Timestamp, from: string, to: string }) {
    let s = "";
    if (data.start) {
      s += this.datePipe.transform(data.start.toDate(), "dd MMMM");
    }
    if (data.start && (data.from || data.to)) {
      s += " — ";
    }
    s += data.from + " › " + data.to;
    return s;
  }

  accomodationReservationToString(data: AccomodationReservation) {
    let s = "";
    if (data.city) {
      s += data.city + " — ";
    }
    if (data.start) {
      s += this.datePipe.transform(data.start.toDate(), "dd MMMM");
    }
    if (data.end) {
      s += " › " + this.datePipe.transform(data.end.toDate(), "dd MMMM");
    }
    return s;
  }

  getCarReservationsWithType(type: ItineraryActivityType) {
    return this.itinerary.reservations.cars.filter((reservation) => reservation.type && reservation.type.toString() === type.toString());
  }

}
